module.exports = __webpack_public_path__ + "img/07-424-424.5fc648d2.png";